

// IELTS STUDENT MANAGMENT CREATE CONSTANTS
export const IELTS_STUDENTMANAGMENT_CREATE_REQUEST = "IELTS_STUDENTMANAGMENT_CREATE_REQUEST";
export const IELTS_STUDENTMANAGMENT_CREATE_SUCCESS = "IELTS_STUDENTMANAGMENT_CREATE_SUCCESS";
export const IELTS_STUDENTMANAGMENT_CREATE_ERR = "IELTS_STUDENTMANAGMENT_CREATE_ERR";


